import script from "./icon-receipt.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-receipt.vue?vue&type=script&lang=ts&setup=true"

import "./icon-receipt.vue?vue&type=style&index=0&id=917e94f0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917e94f0"]])

export default __exports__